/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { ofertaEmpleoDetalleIdJobOfferGet } from '../fn/job-offer/oferta-empleo-detalle-id-job-offer-get';
import { OfertaEmpleoDetalleIdJobOfferGet$Params } from '../fn/job-offer/oferta-empleo-detalle-id-job-offer-get';
import { ofertaEmpleoRangoGet } from '../fn/job-offer/oferta-empleo-rango-get';
import { OfertaEmpleoRangoGet$Params } from '../fn/job-offer/oferta-empleo-rango-get';
import { JobOfferDto } from 'src/app/shared/model/job-offer-detail';
import { ApiResponse } from '../api-response.model';
import {
  JobOfferBasicResult,
  JobOfferAvancedResult,
  JobOffersResponseAvanced,
  JobOffersResponseBasic,
} from 'src/app/shared/model/job-offer-result';
import { UpdateJobOfferData } from '@models/jobOffer-payload-model';

@Injectable({ providedIn: 'root' })
export class JobOfferService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `ofertaEmpleoRangoGet()` */
  static readonly OfertaEmpleoRangoGetPath = '/oferta-empleo/rango';
  /** Path part for operation `ofertaEmpleoIdGet()` */
  static readonly OfertaEmpleoIdGetPath = '/oferta-empleo/';
  /**
   * getByRange.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ofertaEmpleoRangoGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  ofertaEmpleoRangoGet$Response(
    params?: OfertaEmpleoRangoGet$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<any>> {
    return ofertaEmpleoRangoGet(this.http, this.rootUrl, params, context);
  }

  /**
   * getByRange.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ofertaEmpleoRangoGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  ofertaEmpleoRangoGet(
    params?: OfertaEmpleoRangoGet$Params,
    context?: HttpContext
  ): Observable<any> {
    return this.ofertaEmpleoRangoGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<any>): any => r.body)
    );
  }

  /** Path part for operation `ofertaEmpleoDetalleIdJobOfferGet()` */
  static readonly OfertaEmpleoDetalleIdJobOfferGetPath =
    '/detalles-oferta-empleo/';

  /**
   * getDetailById.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ofertaEmpleoDetalleIdJobOfferGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  ofertaEmpleoDetalleIdJobOfferGet$Response(
    params?: OfertaEmpleoDetalleIdJobOfferGet$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<any>> {
    return ofertaEmpleoDetalleIdJobOfferGet(
      this.http,
      this.rootUrl,
      params,
      context
    );
  }

  /**
   * getDetailById.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ofertaEmpleoDetalleIdJobOfferGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  ofertaEmpleoDetalleIdJobOfferGet(
    params?: OfertaEmpleoDetalleIdJobOfferGet$Params,
    context?: HttpContext
  ): Observable<any> {
    return this.ofertaEmpleoDetalleIdJobOfferGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<any>): any => r.body)
    );
  }

  /**
   * getById.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ofertaEmpleoIdGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  ofertaEmpleoIdGet$Response(
    params: { idJobOffer: string },
    context?: HttpContext
  ): Observable<StrictHttpResponse<any>> {
    return this.http.get<any>(
      `${this.rootUrl}${JobOfferService.OfertaEmpleoIdGetPath}${params.idJobOffer}`,
      {
        observe: 'response',
        context,
      }
    ) as Observable<StrictHttpResponse<any>>;
  }

  /**
   * getById.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ofertaEmpleoIdGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  ofertaEmpleoIdGet(
    params: { idJobOffer: string },
    context?: HttpContext
  ): Observable<any> {
    return this.ofertaEmpleoIdGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<any>): any => r.body)
    );
  }

  getJobDetailById(idJobOffer: string): Observable<ApiResponse<JobOfferDto>> {
    const url = `${this.config.rootUrl}/oferta-empleo/${idJobOffer}`;
    return this.http.get<ApiResponse<JobOfferDto>>(url);
  }

  getBasicSearch(filters: {
    textFilter?: string;
    idProvince?: string;
    idJobType?: string;
    minimumSalary?: number;
    maximumSalary?: number;
    skip?: number;
    quantity?: number;
  }): Observable<ApiResponse<any>> {
    const params = new URLSearchParams();

    params.set('textFilter', filters.textFilter ?? '');
    params.set('idProvince', filters.idProvince ?? '');
    params.set('idJobType', filters.idJobType ?? '');
    params.set('minimumSalary', filters.minimumSalary?.toString() ?? '');
    params.set('maximumSalary', filters.maximumSalary?.toString() ?? '');
    params.set('skip', filters.skip?.toString() ?? '0');
    params.set('quantity', filters.quantity?.toString() ?? '10');

    const url = `${
      this.config.rootUrl
    }/oferta-empleo/busqueda-basica?${params.toString()}`;
    return this.http.get<ApiResponse<any>>(url);
  }

  getAdvancedSearch(filters: {
    textFilter?: string;
    idProvince?: string;
    idJobType?: string;
    idArea?: string;
    idEducation?: string;
    publicationDate?: string;
    minimumSalary?: number;
    maximumSalary?: number;
    minimumExperience?: number;
    skip?: number;
    quantity?: number;
  }): Observable<any> {
    const params = new URLSearchParams();

    params.set('textFilter', filters.textFilter ?? '');
    params.set('idProvince', filters.idProvince ?? '');
    params.set('idJobType', filters.idJobType ?? '');
    params.set('idArea', filters.idArea ?? '');
    params.set('idEducation', filters.idEducation ?? '');
    params.set('publicationDate', filters.publicationDate ?? '');
    params.set('minimumSalary', filters.minimumSalary?.toString() ?? '');
    params.set('maximumSalary', filters.maximumSalary?.toString() ?? '');
    params.set(
      'minimumExperience',
      filters.minimumExperience?.toString() ?? ''
    );
    params.set('skip', filters.skip?.toString() ?? '0');
    params.set('quantity', filters.quantity?.toString() ?? '10');
    const url = `${
      this.config.rootUrl
    }/oferta-empleo/busqueda-avanzada?${params.toString()}`;
    return this.http.get<ApiResponse<JobOffersResponseAvanced>>(url);
  }

  getJobOffersByCompany(
    idCompany: string,
    skip: number = 0,
    quantity: number = 1000
  ) {
    const url = `${this.config.rootUrl}/oferta-empleo/por-compania?idCompany=${idCompany}&skip=${skip}&quantity=${quantity}`;
    return this.http.get<any>(url);
  }

  createJobOffer(data: any) {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      Accept: 'application/json',
      Authorization: `Bearer ${localStorage.getItem('token')}`,
    });
    return this.http.post(`${this.config.rootUrl}/oferta-empleo`, data, {
      headers,
    });
  }

  getJobOfferDashboardData(idJobOffer: string) {
    const url = `${this.config.rootUrl}/oferta-empleo/datos-tablero/${idJobOffer}`;
    return this.http.get<any>(url);
  }

  registrarVisita(idJobOffer: string): Observable<any> {
    const url = `${this.config.rootUrl}/oferta-empleo/registrar-visita/${idJobOffer}`;
    return this.http.get<any>(url);
  }

  finalizeJobOffer(idJobOffer: string): Observable<any> {
    return this.http.patch<any>(
      `${this.config.rootUrl}/oferta-empleo/finalizar-oferta-empleo/${idJobOffer}`,
      {},
      {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          Accept: 'application/json',
        }),
      }
    );
  }

  updateJobOffer(idJobOffer: string, data: UpdateJobOfferData) {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      Accept: 'application/json',
    });

    const url = `${this.config.rootUrl}/oferta-empleo/${idJobOffer}`;

    return this.http.patch<any>(url, data, { headers });
  }

  getByIdCompany(
    idCompany: string
  ): Observable<ApiResponse<JobOfferAvancedResult[]>> {
    const url = `${this.config.rootUrl}/oferta-empleo/por-compania?idCompany=${idCompany}&skip=0&quantity=100000`;
    return this.http.get<ApiResponse<JobOfferAvancedResult[]>>(url);
  }
}
